import { CloseButton, Col, Container, Row } from "reactstrap";
import "../../Homepage/Component/Homepage.css";

import nepal from "../../assets/kangaroo/nepalflag.png";
import australia from "../../assets/kangaroo/newzealandflag.png";
import newZealandFlag from "../../assets/kangaroo/newzealandflag.png";
import ukFlag from "../../assets/kangaroo/newzealandflag.png";
import usaFlag from "../../assets/kangaroo/canadaflag.png";
import chinaFlag from "../../assets/kangaroo/newzealandflag.png";
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import PropTypes from "prop-types";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { div } from "framer-motion/client";
import Button from "../../component/button/Button";
import FormClose from "../FormClose/FormClose";
import "./Form.css";
import SectionContainer from "../../Homepage/SectionContainer";
import { X } from "lucide-react";
import Dropdown from "../dropdown/Dropdown";
import country from "../../common/data/country";
import { useMutation, useQuery } from "@tanstack/react-query";
import FormService from "../../services/FormService";
import Destinationcountry from "../../services/Destinationcountry";
import BranchService from "../../services/BranchService";

const Form = ({
  modal,
  toggle,
  heading,
  description,
  additionalField,
  onClickSubmit,
  Explore,
  preferredStudylevel = false,
  closingMessage,
  closingDesc,
  aus = false,
  isEvent = false,
  formOrigin,
}) => {
  const [thankYouModal, setThankYouModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);
  const [countryCode, setCountryCode] = useState(false);
  const [intendedLevel, setintendedLevel] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState(false);
  const [studyLevel, setStudyLevel] = useState(false);
  const [nearestOffice, setNearestOffice] = useState(false);

  const contactnumber = country;

  const fetchDestinationData = async () => {
    const response = await Destinationcountry.getList();
    return response;
  };

  const fetchOffice = async () => {
    const response = await BranchService.getList();
    return response?.items;
  };

  const { error: officeError, data: officeData } = useQuery({
    queryKey: ["officeData"],
    queryFn: fetchOffice,
    onSuccess: (data) => {
      console.log(data);
    },
  });

  const {
    isPending,
    error,
    data: countryData,
  } = useQuery({
    queryKey: ["countryData"],
    queryFn: fetchDestinationData,
  });

  const officeOptions =
    officeData?.map((item) => ({
      id: item.id,
      label: item.officeName,
    })) || [];

  const countryOptions =
    countryData
      ?.filter((item) => item.isActive)
      ?.map((item) => ({
        id: item.id,
        label: item.name,
      })) || [];

  const toggleThankYou = () => setThankYouModal(!thankYouModal);

  const closeBtn = (
    <div className="w-100 d-flex justify-content-end">
      <button className="close-btn" onClick={toggle}>
        <X color="gray" />
      </button>
    </div>
  );

  // Validation schema
  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
      .min(2, "Name must be at least 2 characters")
      .max(100, "Name must not exceed 100 characters")
      .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
      .required("Full name is required"),
    email: Yup.string()
      .trim()
      .required("Email address is required")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        "Please enter a valid email address"
      )
      .max(254, "Email address is too long"),
    phone: Yup.string()
      .transform((value) => (value ? String(value) : "")) // ensure it's a string
      .matches(/^[0-9]+$/, "Phone number must contain only numbers") // no letters/special chars
      .min(10, "Phone number must be at least 10 digits") // minimum 10 digits
      .required("Phone number is required"),
    intendedLevel: Yup.string().required(
      aus
        ? "Please select preferred study level"
        : "Please select study destination"
    ),
    callBackTime: additionalField
      ? Yup.string().required("Please select callback time")
      : Yup.string(),
    preferedBranchID: Yup.string().required(
      preferredStudylevel
        ? "Please select study level"
        : "Please select nearest office"
    ),
    message: Yup.string().max(1000, "Message must not exceed 1000 characters"),
  });

  // Initial values
  const initialValues = {
    fullName: " ",
    email: " ",
    phone: " ",
    countryCode: "+977",
    intendedLevel: " ",
    callBackTime: " ",
    preferedBranchID: " ",
    preferedCountryID: " ",
    message: " ",
    formOrigin: formOrigin,
  };

  const mutation = useMutation({
    mutationFn: async (formData) => {
      if (isEvent === true) {
        return await FormService.eventForm(formData);
      } else {
        return await FormService.create(formData);
      }
    },
    onError: (error) => {
      console.error("Error submitting form:", error);
    },
    onSuccess: () => {
      console.log("Form submitted successfully");
    },
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const payload = {
      ...values,
      phone: String(values.phone),
      formOrigin: formOrigin,
    };

    console.log("Form submitted with payload:", payload);
    mutation.mutate(payload);

    toggle();
    toggleThankYou();
    if (onClickSubmit) onClickSubmit();

    setTimeout(() => {
      resetForm();
      setSelectedItem(false);
      setCountryCode(false);
      setSelectedDestination(false);
      setSubmitting(false);
    }, 500);
  };

  return (
    <div>
      <SectionContainer>
        <Modal
          isOpen={modal}
          toggle={toggle}
          modalClassName="custom-modal-main"
          size="lg"
        >
          <ModalHeader toggle={toggle} close={closeBtn}></ModalHeader>
          <ModalBody>
            <Container
              fluid
              className="d-flex justify-content-center align-items-center h-auto"
              style={{ width: "80%" }}
            >
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnChange={true}
                validateOnBlur={true}
              >
                {(formik) => (
                  <Row>
                    <Col>
                      <div>
                        <h1 className="font-heading lh-1">{heading}</h1>
                        <p className="country-paragraph-text mb-3">
                          {description}
                        </p>
                      </div>
                      <div className="d-flex flex-column gap-2">
                        <div>
                          <label htmlFor="fullName" className="font-label">
                            Full Name*
                          </label>
                          <Field
                            type="text"
                            name="fullName"
                            className={`form-control form-box py-3 ${formik.touched.fullName && formik.errors.fullName
                              ? "is-invalid"
                              : null
                              }`}
                            id="fullName"
                          />
                          <ErrorMessage
                            name="fullName"
                            component="div"
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875rem" }}
                          />
                        </div>

                        <div>
                          <label htmlFor="email" className="font-label">
                            Email Address*
                          </label>
                          <Field
                            type="email"
                            name="email"
                            className={`form-control form-box py-3 ${formik.touched.email && formik.errors.email
                              ? "is-invalid"
                              : null
                              }`}
                            id="email"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875rem" }}
                          />
                        </div>

                        <div>
                          <label htmlFor="phone" className="font-label">
                            Phone Number*
                          </label>
                          <div
                            className="d-flex justify-content-center align-items-start position-relative"
                            style={{
                              borderRadius: "8px",
                              transition: "box-shadow 0.2s ease-in-out",
                              border:
                                formik.errors.phone || formik.errors.countryCode
                                  ? ""
                                  : "none", // highlight border if error
                            }}
                            onFocus={(e) => {
                              e.currentTarget.style.boxShadow =
                                "0 0 0 4px rgba(13, 110, 253, 0.25)";
                            }}
                            onBlur={(e) => {
                              e.currentTarget.style.boxShadow = "none";
                            }}
                          >
                            <div style={{ flex: "0 0 6rem" }}>
                              <Dropdown
                                items={contactnumber.map((item) => ({
                                  id: item.id,
                                  label: item.countryCode,
                                  flag: item.flagImg,
                                }))}
                                width="9rem"
                                selectedItem={countryCode}
                                setSelectedItem={(item) => {
                                  setCountryCode(item);
                                  formik.setFieldValue(
                                    "countryCode",
                                    item?.label || null
                                  );
                                }}
                                phoneNumber={true}
                                placeholder="+977"
                                placeholderFlag={nepal}
                              />
                            </div>
                            <div style={{ flex: 1 }}>
                              <Field
                                type="number"
                                name="phone"
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="form-control form-box py-3"
                                style={{
                                  borderLeft: "0",
                                  borderTop: "2px solid #687C86",
                                  borderRight: "2px solid #687C86",
                                  borderBottom: "2px solid #687C86",
                                  borderTopRightRadius: "8px",
                                  borderBottomRightRadius: "8px",
                                  borderTopLeftRadius: "0",
                                  borderBottomLeftRadius: "0",
                                  boxSizing: "border-box",
                                  paddingLeft: "12px",
                                  width: "100%",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                          </div>

                          {/* Show error for the whole component */}
                          {((formik.touched.phone && formik.errors.phone) ||
                            (formik.touched.countryCode &&
                              formik.errors.countryCode)) && (
                              <div
                                className="text-danger mt-1"
                                style={{ fontSize: "0.875rem" }}
                              >
                                {formik.errors.countryCode
                                  ? formik.errors.countryCode
                                  : formik.errors.phone}
                              </div>
                            )}
                        </div>

                        {aus ? (
                          <div>
                            <label
                              htmlFor="intendedLevel"
                              className="font-label"
                            >
                              Preferred Study Level*
                            </label>
                            <Dropdown
                              items={[
                                { id: "Bachelor's", label: "Bachelor's" },
                                { id: "Master's", label: "Master's" },
                                { id: "Masters by Research", label: "Masters by Research" },
                              ]}
                              selectedItem={intendedLevel}
                              setSelectedItem={(item) => {
                                setintendedLevel(item);
                                formik.setFieldValue(
                                  "intendedLevel",
                                  item?.label || null
                                );
                              }}
                              placeholder=" "
                            />
                            <ErrorMessage
                              name="intendedLevel"
                              component="div"
                              className="text-danger mt-1"
                              style={{ fontSize: "0.875rem" }}
                            />
                          </div>
                        ) : (
                          <div>
                            <label
                              htmlFor="preferedCountryID"
                              className="font-label"
                            >
                              Preferred Study Destinations*
                            </label>
                            <Dropdown
                              items={countryOptions}
                              selectedItem={selectedDestination}
                              setSelectedItem={(item) => {
                                setSelectedDestination(item);
                                formik.setFieldValue(
                                  "preferedCountryID",
                                  item?.id || null
                                );
                              }}
                              placeholder=" "
                            />
                            <ErrorMessage
                              name="preferedCountryID"
                              component="div"
                              className="text-danger mt-1"
                              style={{ fontSize: "0.875rem" }}
                            />
                          </div>
                        )}

                        {additionalField && (
                          <>
                            <label
                              htmlFor="callBackTime"
                              className="font-label"
                            >
                              What time can we call you back*
                            </label>
                            <Dropdown
                              items={[
                                { id: "10 AM - 11 AM", label: "10 AM - 11 AM" },
                                { id: "11 AM - 12 PM", label: "11 AM - 12 PM" },
                                { id: "12 PM - 1 PM", label: "12 PM - 1 PM" },
                                { id: "1 PM - 2 PM", label: "1 PM - 2 PM" },
                                { id: "2 PM - 3 PM", label: "2 PM - 3 PM" },
                                { id: "3 PM - 4 PM", label: "3 PM - 4 PM" },
                                { id: "4 PM - 5 PM", label: "4 PM - 5 PM" },
                              ]}
                              selectedItem={selectedItem}
                              setSelectedItem={(item) => {
                                setSelectedItem(item);
                                formik.setFieldValue(
                                  "callBackTime",
                                  item?.label || null
                                );
                              }}
                              placeholder=" "
                            />
                            <ErrorMessage
                              name="callBackTime"
                              component="div"
                              className="text-danger mt-1"
                              style={{ fontSize: "0.875rem" }}
                            />
                          </>
                        )}

                        {preferredStudylevel ? (
                          <div>
                            <label
                              htmlFor="intendedLevel"
                              className="font-label"
                            >
                              Preferred Study Level*
                            </label>
                            <Dropdown
                              items={[
                                { id: "Bachelor's", label: "Bachelor's" },
                                { id: "Master's", label: "Master's" },
                                { id: "Masters by Research", label: "Masters by Research" },
                              ]}
                              selectedItem={studyLevel}
                              setSelectedItem={(item) => {
                                setStudyLevel(item);
                                formik.setFieldValue(
                                  "intendedLevel",
                                  item?.label || null
                                );
                              }}
                              placeholder=" "
                            />
                            <ErrorMessage
                              name="preferedBranchID"
                              component="div"
                              className="text-danger mt-1"
                              style={{ fontSize: "0.875rem" }}
                            />
                          </div>
                        ) : (
                          <div>
                            <label
                              htmlFor="preferedBranchID"
                              className="font-label"
                            >
                              Nearest KEF Office*
                            </label>
                            <Dropdown
                              items={officeOptions}
                              selectedItem={nearestOffice}
                              setSelectedItem={(item) => {
                                setNearestOffice(item);
                                formik.setFieldValue(
                                  "preferedBranchID",
                                  item?.id || null
                                );
                              }}
                              placeholder=" "
                            />
                            <ErrorMessage
                              name="preferedBranchID"
                              component="div"
                              className="text-danger mt-1"
                              style={{ fontSize: "0.875rem" }}
                            />
                          </div>
                        )}

                        <div>
                          <label htmlFor="message" className="font-label">
                            Message (if any)
                          </label>

                          <Field
                            as="textarea"
                            name="message"
                            className={`form-control form-height form-box ${formik.touched.message && formik.errors.message
                              ? "is-invalid"
                              : null
                              }`}
                            id="message"
                            rows={4}
                            style={{ resize: "vertical" }}
                          />

                          <ErrorMessage
                            name="message"
                            component="div"
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875rem" }}
                          />
                        </div>
                      </div>

                      {/* Hidden button to capture form submission */}
                      <button
                        type="button"
                        style={{ display: "none" }}
                        ref={(btn) => {
                          if (btn) {
                            btn.onclick = () => formik.handleSubmit();
                          }
                        }}
                        id="hidden-submit-btn"
                      />
                    </Col>
                  </Row>
                )}
              </Formik>
            </Container>
          </ModalBody>
          <Container
            fluid
            className="d-flex justify-content-end align-items-center w-75 h-auto p-0"
          >
            <ModalFooter className="p-0" style={{ borderTop: "none" }}>
              <div className="mb-5 p-0" style={{ marginLeft: "4rem" }}>
                <Button
                  label="SUBMIT & GET STARTED"
                  width="100%"
                  height="70.86661px"
                  margin="20px auto"
                  padding="0px"
                  textAlign="left"
                  fontSize={22}
                  fontWeight="500"
                  textColor="#890295"
                  fontFamily="Proxima Nova Bold"
                  onClick={() => {
                    const submitBtn =
                      document.getElementById("hidden-submit-btn");
                    if (submitBtn) submitBtn.click();
                  }}
                />
              </div>
            </ModalFooter>
          </Container>
        </Modal>
        <FormClose
          modal={thankYouModal}
          toggle={toggleThankYou}
          heading={closingMessage}
          description={closingDesc}
        />
      </SectionContainer>
    </div>
  );
};

export default Form;
